var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36664 6.1L10.0166 0.45C10.15 0.316667 10.3083 0.25 10.4916 0.25C10.675 0.25 10.8333 0.316667 10.9666 0.45C11.1 0.583333 11.1666 0.741667 11.1666 0.925C11.1666 1.10833 11.1 1.26667 10.9666 1.4L4.83331 7.53333C4.69998 7.66667 4.54442 7.73333 4.36664 7.73333C4.18886 7.73333 4.03331 7.66667 3.89998 7.53333L1.03331 4.66667C0.899975 4.53333 0.836086 4.375 0.841642 4.19167C0.847197 4.00833 0.916642 3.85 1.04998 3.71667C1.18331 3.58333 1.34164 3.51667 1.52498 3.51667C1.70831 3.51667 1.86664 3.58333 1.99998 3.71667L4.36664 6.1Z",
    fill: "#0B815A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.117263f62c6265f29b1bf565630e8c19.svg";
export { ForwardRef as ReactComponent };